import { mainRecordTypeOf } from '@platform/engine/menu/moduleSections';
import { useModuleDefinition, useModulePackage } from '@platform/modularity';
import { analysisModuleKey } from './designSections';
import type { IAnalysisModule } from './IAnalysisModule';

/**
 * Модуль бізнес-аналізу поза його маршрутом (сторінки «Проєктування» іншого модуля, прототип v4 baFor): вантажить пакет (рядки, стан
 * списків) і визначення з сервера; головний тип — записи аналізу (вид, модуль, MoSCoW…).
 */
export function useAnalysisModule(): IAnalysisModule {
  const pkg = useModulePackage(analysisModuleKey);
  const { data, isLoading, error } = useModuleDefinition(analysisModuleKey);
  const rt = data ? mainRecordTypeOf(data) : undefined;
  return { module: data, rt, loading: pkg.status === 'loading' || (isLoading && !data), error: error ?? pkg.error };
}
